import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          //  // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Afolabi Phillips</div>
            <div className="Exco-Tittle">President</div>
            <br />

            <div className="Excos-Bio">
              Afolabi Phillips is a seasoned professional with a multifaceted
              career spanning IT analysis and property investment. With
              extensive experience in information management and technology and
              a successful track record in real estate ventures, he brings a
              unique blend of technical expertise and strategic insight into his
              work. <br /> <br />
              Having earned his BSc in Sociology from the University of Lagos,
              Nigeria, and his MSc in Information Management from Lancaster
              University, UK, Afolabi is deeply rooted in both his educational
              and professional pursuits. He is dedicated to ensuring increased
              productivity, better decision-making, streamlined business
              processes, and cost savings for organisations while also
              leveraging his passion for real estate opportunities to build
              financial wealth and independence. <br /> <br />
              Unilag Alumni was founded in the UK in 1998 by Bisi Alabi and
              Afolabi. It was dormant for ten years when they both migrated to
              Nigeria. It was relaunched in 2016 with a new vigour and immense
              support from the previous president” Adeyinka Jegede”. <br />
              Afolabi had the privilege of serving as the vice president from
              2017 until 2022, during which time we witnessed significant growth
              and achievement with the UK Alumni Family. <br /> <br />
              It has been a rewarding experience to contribute to the
              development and engagement of the UK family. Afolabi's commitment
              to his alma mater is evident through his role as the current
              president of the Unilag Alumni UK Chapter, where he actively
              engages in fostering connections and supporting the alumni
              community. <br /> <br />
              Outside of his professional endeavours, Afolabi finds fulfilment
              in his family life, being happily married with children.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
